module.exports = __webpack_public_path__ + "img/first_bank-logo.73a81ccc.svg";